import { useBaseAPI } from 'apiServices/baseAPI';

export function useAppointmentAPI({ resourceId }) {
  return useBaseAPI(
    {
      method: 'GET',
      // route: 'hapi/fhir/Appointment',
      route: `user/fhir/Appointment?_content=${resourceId}&_count=2147483647&_sort=-date`,
      additionalHeaders: {
        Accept: '*/*',
      },
    },
    !resourceId,
  );
}
